import { Alignment } from "./Alignment/Alignment";
import { Color } from "./Color/Color";
import { Delete } from "./Delete/Delete";
import { Font } from "./Font/Font";
import { FontSize } from "./FontSize/FontSize";
import { FontSpacing } from "./FontSpacing/FontSpacing";
import { MoreOptions } from "./MoreOptions/MoreOptions";
import { TextDecoration } from "./TextDecoration/TextDecoration";
import { useTextSettings } from "./useTextSettings";

interface TextSettingsProps {
    id: string;
}

export const TextSettings = ({ id }: TextSettingsProps) => {
    useTextSettings();
    return (
        <div className="flex flex-wrap items-center gap-2">
            <Color textBoxId={id} />
            <Font textBoxId={id} />
            <FontSize textBoxId={id} />
            <TextDecoration textBoxId={id} />
            <Alignment textBoxId={id} />
            <FontSpacing textBoxId={id} />
            <Delete textBoxId={id} />
            <MoreOptions textBoxId={id} />
        </div>
    );
};
